import React, { Component } from "react";


class Tableau extends Component {
  componentDidMount() {
    const script = document.createElement("script");

    script.src = "https://tableau-prod.ngap.nike.com/javascripts/api/viz_v1.js";
    script.async = true;

    document.body.appendChild(script);
  };
  render() {
      const { name } = this.props
    return (
        <React.Fragment>

                    <object className='tableauViz' width='100%' height='2000px'>
                        <param name='host_url' value='https%3A%2F%2Ftableau-prod.ngap.nike.com%2F' /> 
                        <param name='embed_code_version' value='3' />
                        <param name='site_root' value='&#47;t&#47;NDD' />
                        <param name='name' value={name} />
                        <param name='tabs' value='yes' />
                        <param name='toolbar' value='yes' />
                        <param name='showAppBanner' value='false' />
                        <param name='filter' value='iframeSizedToWindow=true' />
                    </object>
        
        </React.Fragment>
    );
  }
}
 
export default Tableau;